<div>
  <table
    odxTable
    [data]="dataToDisplay()"
    [headerData]="headerData"
    (sorted)="sorted($event)"
    (filtered)="filter($event)"
    aria-describedby="cloud-project-selection"
  >
    <thead>
      <th></th>
    </thead>
    @for (tableRow of dataToDisplay(); track tableRow) {
      <tr
        odx-table-row
        [ngClass]="{ selected: selected === tableRow.cloudProjectMetadata }"
        (click)="onClickRow(tableRow.cloudProjectMetadata)"
      >
        <td odx-table-cell>{{ tableRow.displayName }}</td>
        <td odx-table-cell>{{ tableRow.customerName }}</td>
        <td odx-table-cell [odxTooltip]="convertTimestampToDate(tableRow.cloudProjectMetadata.lastModifiedOn)">
          {{ tableRow.lastModifiedOn }}
        </td>
        <td odx-table-cell>
          @for (type of tableRow.projectType; track type; let last = $last) {
            {{ type }}
            @if (!last) {
              <span>,</span>
            }
          }
        </td>
        <td odx-table-cell>
          <odx-chip removable="false" size="small" variant="secondary" i18n="@@projectCard.projectStatus" class="chip">
            <odx-icon [name]="tableRow.icon" alignleft></odx-icon> {{ tableRow.projectStatus }}
          </odx-chip>
        </td>
        <td odx-table-cell></td>
      </tr>
    }
  </table>
</div>
<div>
  <odx-paginator
    [pageSize]="tableSize"
    [length]="total"
    [pageIndex]="pageIndex"
    (pageChanged)="pageChanged($event)"
    [getRangeContentFn]="getRangeContentFn"
    [getSummaryContentFn]="getSummaryContentFn"
  ></odx-paginator>
</div>
